export default __webpack_public_path__ + "static/case-img-9cabda04df48e1f6ab2fafd926176611.jpg";